import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M7.402 3.126l7 7-7 7L6 15.724l5.598-5.598L6 4.528l1.402-1.402z" fill="#000" /></svg>;